import CustomHeader from './CustomHeader';

export const getColumns = (channelFilter, setDefinition, getChartType) => {
	function handleColumnHeaderClick(headerName) {
		setDefinition({
			isDrawerOpened: true,
			metricType: getChartType(headerName),
		});
	}

	if (channelFilter == 'Omni') {
		return [
			{
				headerName: 'Sales',
				hide: true,
				children: [
					{
						headerName: 'Net Sales',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Net Sales',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Units',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Units',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'AUR',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'AUR',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
				],
			},

			{
				headerName: 'Fulfillment Channel Sales Breakdown',
				children: [
					{
						headerName: 'Buy In Store (BIS)',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Buy In Store (BIS)',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Pick Up (PU)',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Pick Up (PU)',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Delivery',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Delivery',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Ship From Store (SFS)',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Ship From Store (SFS)',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Ship To Home (S2H)',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Ship To Home (S2H)',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Ship to Store (S2S)',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Ship to Store (S2S)',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
				],
			},
		];
	} else if (channelFilter == 'eCom') {
		return [
			{
				headerName: 'Sales',
				hide: true,
				children: [
					{
						headerName: 'Net Sales',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Net Sales',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Units',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Units',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'AUR',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'AUR',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
				],
			},
			{
				headerName: 'Fulfillment Channel Sales Breakdown',
				children: [
					{
						headerName: 'Ship To Home (S2H)',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Ship To Home (S2H)',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Ship to Store (S2S)',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Ship to Store (S2S)',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
				],
			},
		];
	} else {
		return [
			{
				headerName: 'Sales',
				hide: true,
				children: [
					{
						headerName: 'Net Sales',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Net Sales',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Units',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Units',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'AUR',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'AUR',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
				],
			},

			{
				headerName: 'Fulfillment Channel Sales Breakdown',
				children: [
					{
						headerName: 'Buy In Store (BIS)',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Buy In Store (BIS)',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Pick Up (PU)',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Pick Up (PU)',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Delivery',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Delivery',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Ship From Store (SFS)',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Ship From Store (SFS)',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
				],
			},

			{
				headerName: 'Inventory',
				children: [
					{
						headerName: 'Store On Hand Quantity',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Store On Hand Quantity',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Store On Order Quantity',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Store On Order Quantity',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Store In Transit Quantity',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Store In Transit Quantity',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Store In Warehouse Quantity',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Store In Warehouse Quantity',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Total Store Inventory',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Total Store Inventory',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
				],
			},
			{
				headerName: 'Replenishment',
				children: [
					{
						headerName: 'Repl Instock % (Store)',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Repl Instock % (Store)',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
				],
			},
			{
				headerName: 'Points of Distribution',
				children: [
					{
						headerName: 'Traited Store Count',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Traited Store Count',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Traited Item Count',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Traited Item Count',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Valid Store Count',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Valid Store Count',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
				],
			},
			{
				headerName: 'Velocity',
				children: [
					{
						headerName: 'Dollar/Store/Week(Day)',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Dollar/Store/Week(Day)',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Units/Store/Week(Day)',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Units/Store/Week(Day)',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
				],
			},
			{
				headerName: 'Online Pickup and Delivery',
				children: [
					{
						headerName: 'Total Order Quantity',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Total Order Quantity',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Pre Substitute Quantity',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Pre Substitute Quantity',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Substitute Quantity',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Substitute Quantity',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Nil Pick Quantity',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Nil Pick Quantity',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'First Time Pick Rate',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'First Time Pick Rate',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Nil Pick Rate',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Nil Pick Rate',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Pre Substitute Rate',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Pre Substitute Rate',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
					{
						headerName: 'Post Subtitute Rate',
						headerGroupComponent: CustomHeader,
						headerGroupComponentParams: {
							displayName: 'Post Subtitute Rate',
							handleOnClick: handleColumnHeaderClick,
						},
						children: [],
					},
				],
			},
		];
	}
};
